import { Injectable, signal, TemplateRef } from '@angular/core';

// Lets a routed page contribute controls to the shell's page-header row, so the heading, the
// facility select and the page's own toolbar render on one line. The page registers its
// <ng-template #actions> and clears it on destroy; the shell renders whatever is set.
@Injectable({
  providedIn: 'root'
})
export class PageActionsService {

  readonly template = signal<TemplateRef<unknown> | null>(null);
}
